import { replaceWhiteLabelTitle } from 'library-@/utils/replaceWhiteLabelTitle';

export default function setTitle({ locale = 'en', isWhiteLabel = false }) {
    const title = {
        cn: '历史记录 - 智慧芽',
        en: 'History - Patsnap',
        jp: '履歴 - Patsnap',
        de: 'History - Patsnap',
        tw: '歷史記錄 - 智慧芽'
    };
    document.title = replaceWhiteLabelTitle({ title: title[locale] || title['en'], isWhiteLabel });
}
